const getPathArguments = (array, IDField) => {
    const IDs = []
    Object.values(array).forEach((elem) => IDs.push(elem[IDField]))

    const uniq = [...new Set(IDs.filter((e) => e && e.length !== 0))]
    return uniq.toString()
}

export default getPathArguments
